export const BASIC = 'BASIC';
export const ADVANCED = 'ADVANCED';